export default __webpack_public_path__ + "static/media/Help_Circle_24px.9f8882db.svg";